import { useEffect, useState } from "react";
import "./BusinessIdeas.css"
import fetchAllBusinessIdeas from "./packages/fetchAllBusinessIdeas";
import EditableBusinessIdea from "../../../../Admin/AdminPastGeb/components/EditableBusinessIdea/EditableBusinessIdea";
import ImgUrlConstants from "../../../../../utils/imgUrlConstants";

const BusinessIdeas = ({ id, isAdmin }) => {
  let [businessIdeas, setBusinessIdeas] = useState([]);
  useEffect(() => {
    fetchAllBusinessIdeas({ editionId: id, setBusinessIdeas: setBusinessIdeas });
  }, [id]);
  // console.log("bi = ", businessIdeas);

  return (
    <div className="pg_bi" >
      {
        isAdmin ?
          <EditableBusinessIdea id={id}
            isActionCreate={true}
            PopupTitle={"Add New Business Idea"}
            businessDescription={""}
            businessName={""} />
          : ""
      }
      {businessIdeas.map((bi, index) => {
        const remainder = index % 2;
        return (
          <div className={remainder === 0 ? "pg_bi_container" : "pg_bi_reverse_container"}
            key={index} >
            {
              isAdmin ?
                <EditableBusinessIdea id={bi._id}
                  isActionCreate={false}
                  businessDescription={bi.description}
                  businessName={bi.title} />
                : ""
            }
            <div className="pg_bi_left pg_bi_img_container ">
              <img className="pg_bi_avatar"
                src={`${ImgUrlConstants.PAST_GEB_BUSINESS_PIC}/${bi._id}.png`}
                alt="pp" />
            </div>
            <div className="pg_bi_right pg_bi_content_container ">
              <div className="pg_bit_title">
                {bi.title}
              </div>
              <div className="pg_bit_description">
                {bi.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BusinessIdeas;
